import React, { useEffect, useRef, useState } from "react";
import "./admintable.css";
import Topbar from "../Global/topbar";
import { Link, useNavigate } from "react-router-dom";
import TableBody2 from "../Table container/tablebody";
import CachedIcon from "@mui/icons-material/Cached";
import { getAdmin } from "../../services/api/admin";

export default function AdminTable() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [loader, setLoder] = useState(true);
  const [data, setData] = useState(false);
  const [notfound, setNotFound] = useState(false);
  const [APIdata, setAPIdata] = useState([]);
  const menu = true;
  const [limit, setLimit] = useState(5);
  const [total, setTotal] = useState(0);
  const [skip, setSkip] = useState("");
  const [reload, setReload] = useState();
  const [pages, setPages] = useState("");
  const deleted = true;
  const start_key = useRef({ 1: null });
  const page = useRef(1);
  const activete_data = "true";
  const reset = true;

  useEffect(() => {
    setPages((prev) => !prev);
  }, [search]);

  const handleclick = () => {
    navigate("/admin/super_admin/create_super_admin");
  };
  const headers = [
    { topic: "#" },
    { topic: "Name" },
    { topic: "Id" },
    { topic: "Role" },
    { topic: "Email" },
    // {topic : 'Phone Number'},
    { topic: "Active" },
    // {topic : 'Photo'},
    { topic: "Action" },
  ];

  const fetchAdmin = async () => {
    const paginationKey = start_key.current[page.current];
    getAdmin(search, limit, paginationKey)
      .then((response) => {
        if (response.data.status) {
          if (response?.data?.data?.data.length === 0) {
            setLoder(false);
            setNotFound(true);
            setData(true);
            setTotal(response?.data?.data?.total);
          } else {
            setLoder(false);
            setNotFound(false);
            setData(true);
            setTotal(response?.data?.data?.total);
            setAPIdata(response?.data?.data?.data || []);
            start_key.current[page.current + 1] =
              response?.data?.data?.last_key || null;
          }
        } else {
          setLoder(false);
          setNotFound(true);
        }
      })
      .catch((error) => {
        setLoder(false);
        setNotFound(true);
        console.log(error.message);
      });
  };

  useEffect(() => {
    setAPIdata([]);
    setLoder(true);
    setNotFound(false);
    const delayDebounceFn = setTimeout(() => {
      fetchAdmin();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [search, skip, limit, reload]);

  const handleReload = () => {
    setReload((prev) => !prev);
  };

  const cell = [
    { topic: "name" },
    { topic: "id" },
    { topic: "role" },
    { topic: "email" },
    // {topic : 'number'},
    { topic: "activate" },
    // {topic : 'photo'}
  ];

  const path = "/admin/super_admin/admin_details";

  return (
    <div className="AdminTable-main">
      <div className="AdminTable-user">
        <Topbar />
        <div className="top-mid-Admin">
          <h1>Admin List</h1>
          <Link to="" style={{ display: "none" }}>
            Dashboard
          </Link>{" "}
          <Link to="/admin/super_admin">Admin List</Link> &#62;
        </div>
        <div className="tob-bottom-Admin">
          <div className="button-box-user">
            <button onClick={handleclick}> + Create Admin</button>
          </div>
          <div>
            <input
              type="text"
              className="input-Admin"
              placeholder="&#61442; Search"
              onChange={(e) => {
                setSearch(e.target.value);
                setSkip(0);
                start_key.current[1] = undefined;
                page.current = 1;
              }}
              style={{
                fontfamily: "Arial, FontAwesome",
                marginRight: "4px",
              }}
            />
            <button onClick={handleReload}>
              <CachedIcon />
            </button>
          </div>
        </div>
        <div className="table1">
          <TableBody2
            headers={headers}
            APIdata={APIdata}
            cell={cell}
            path={path}
            loader={loader}
            notfound={notfound}
            data={data}
            menu={menu}
            setSkip={setSkip}
            total={total}
            setLimit={setLimit}
            pages={pages}
            deleted={deleted}
            newPage={page}
            setReload={setReload}
            activete_data={activete_data}
            reset={reset}
          />
        </div>
      </div>
    </div>
  );
}
